import Page from "~/components/Page";
import Section from "~/components/Section";
import Container from "~/components/Container";
import SignInForm from "~/components/form/SignInForm";
import Card from "~/components/ui/Card";
import {useSearchParams} from "@solidjs/router";

export default function SignIn() {

    const [searchParams] = useSearchParams()

    return (
        <Page
            metaTitle="Sign In"
            metaDescription="Access your Graceful Space Yoga account to book classes, manage your class passes and view your bookings.">
            <Section>
                <Container>
                    <Card>
                        <SignInForm email={searchParams.email as string | undefined}
                                    redirect={searchParams.redirect ? searchParams.redirect as string : "/account"}/>
                    </Card>
                </Container>
            </Section>
        </Page>
    )
}